// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"d319acdb","898":"c9580770"}[chunkId] + ".chunk.css";
};